const level1 = [
    "010000 Roundwood",
    "020000 Fuelwood and energy",
    "030000 Sawnwood and treated wood",
    "040000 Engineered wood products",
    "050000 Wood based panels",
    "060000 Wood manufacturers",
    "070000 Indoor Furniture",
    "080000 Exterior products",
    "090000 Wooden Buildings and construction material",
    "100000 Pulp",
    "110000 Paper and paper board",
    "110000 Paper and paper board (continued)",
    "120000 Non-wood products",
    "120000 Non-wood products (continued)",
    "130000 Other products",
    "N10 Other NTFP n.e.c",
    "N1 Barks",
    "N2 Soil conditioner and substrates",
    "N3 Cork and articles of cork",
    "N4 Straw, wicker, rattan and similar",
    "N5 Bamboo and articles of bamboo",
    "N6 Plants and parts of plants",
    "N7 Natural gums, oils and derivatives",
    "N8 Chemical, medicinal and cosmetic",
    "N9 Food",
    "Not applicable",
    "P10 Other pulp and paper products n.e.c.",
    "P1 Pulp",
    "P2 Paper",
    "P3 Paperboard",
    "P4 Corrugated paper and paperboard",
    "P5 Packaging and wrappings of paper",
    "P6 Household and sanitary products",
    "P7 Stationery of paper",
    "P8 Printed materials",
    "P9 Bobbins, spools, rolls and similar",
    "W10 Wood package and similar",
    "W11 Wood for construction",
    "W12 Indoor furniture",
    "W13 Outdoor furniture and gardening",
    "W14 Musical instruments",
    "W15 Recreational goods",
    "W16 Household articles",
    "W17 Stationery of wood",
    "W18 Other manufactured wood products",
    "W19 Other wood products n.e.c.",
    "W1 Rough wood",
    "W2 Wood charcoal",
    "W3 Wood in chips or particles",
    "W4 Impregnated/treated wood",
    "W5 Solid wood (sawn, chipped, peeled)",
    "W6 Products from planing mill",
    "W7 Veneer",
    "W8 Wood panels",
    "W9 Engineered wood products"
];

const level2AllOptions = [
    "010100 Sawlogs and veneer logs",
    "010200 Pulpwood",
    "010300 Chips and particles",
    "010400 Wood residues",
    "010500 Bark",
    "010600 Other roundwood",
    "020100 Fuelwood",
    "020200 Charcoal",
    "020300 Pellets and brickets",
    "020400 Energy",
    "030100 Sawnwood",
    "030200 Railway sleepers / ties",
    "030300 Impregnated or treated wood",
    "040100 Cross Laminated Timber (CLT)",
    "040200 Finger Jointed Lumber",
    "040300 Glue Laminated Products (Glulam)",
    "040400 Laminated Veneer Lumber (LVL)",
    "040500 Parallel Strand Lumber (PSL)",
    "040600 I-Joists / I-Beams",
    "040700 Trusses & Engineered Panels",
    "040800 Scantlings",
    "040900 Composite board",
    "041000 Other engineered wood products",
    "050100 Veneer sheets",
    "050200 Plywood",
    "050300 Blockboard",
    "050400 Panels for transportation",
    "050500 Particle board",
    "050600 Fibreboard",
    "050700 Cement board",
    "050800 Other wood based panels",
    "060100 Wood packaging",
    "060200 Household goods",
    "060300 Tools and turned wood",
    "060400 Other manufactured wood",
    "070100 Tables",
    "070200 Chairs and stools",
    "070300 Sofas and armchairs",
    "070400 Benches",
    "070500 Bedroom Furniture",
    "070600 Storage systems and units",
    "070700 Kitchen units and worktops",
    "070800 Office furniture",
    "070900 Educational / Institutional furniture",
    "071100 Childrens Furniture",
    "071200 Custom Furniture",
    "071300 Furniture components",
    "071400 Other furniture",
    "080100 Garden Furniture / Outdoor Products",
    "080200 Landscaping Timbers",
    "080300 Street furniture",
    "080400 Other exterior products",
    "090100 General Wooden Buildings and constructions",
    "090200 Integrated Parts of Wooden Buildings and constructions",
    "090300 Wood material for construction",
    "100100 Mechanical pulp",
    "100200 Semichemical pulp",
    "100300 Dissolving pulp and derivatives",
    "100400 Chemical pulp",
    "100500 Pulp from recycled material",
    "100600 Other Pulp and derivatives",
    "110100 Graphic papers",
    "110200 Printed matter",
    "110300 Household and sanitary paper",
    "110400 Packaging materials",
    "110400 Packaging materials (continued)",
    "110500 Stationery Products",
    "110600 Other paper and paperboard",
    "110700 Other converted paper products",
    "120100 Cork and cork products",
    "120200 Rubber / Latex",
    "120300 Food",
    "120400 Resins and its derivatives",
    "120500 Essential oils",
    "120600 Rattan and other natural fibers",
    "120700 Plants and their parts",
    "120800 Chemical, medicinal and cosmetic products",
    "120900 Other non-wood products",
    "N3.1 Natural cork, raw or boiled",
    "N3.2 Cork powder",
    "N3.3 Cork granules",
    "N3.4 Cork stoppers",
    "N3.5 Rolls and panels of compressed cork",
    "N3.6 Cork disks",
    "N3.7 Articles of cork",
    "N4.1 Rattan cane (rough form)",
    "N4.2 Rattan taper (clean, peeled etc)",
    "N4.3 Decorative objects and wickerwork",
    "N4.4 Rattan furniture",
    "N4.5 Rattan furniture components",
    "N5.10 Bamboo pulp",
    "N5.1 Natural bamboo",
    "N5.2 Edible bamboo",
    "N5.3 Fuel bamboo",
    "N5.4 Bamboo plywood",
    "N5.5 Bamboo flooring",
    "N5.6 Bamboo furniture",
    "N5.7 Bamboo home articles, wickerwork",
    "N5.8 Bamboo textiles",
    "N5.9 Bamboo vinegar",
    "N6.1 Flowers",
    "N6.2 Grasses, ferns, mosses and lichens",
    "N6.3 Wholetreesor plants",
    "N6.4 Pine cones",
    "N7.1 Rubber/ Latex",
    "N7.2 Gum resin",
    "N7.3 Resin and manufactured products",
    "N7.4 Tannin",
    "N7.5 Essential oils",
    "N8.1 Ethanol",
    "N8.2 Medicinal plants and products",
    "N8.3 Pharmaceutical raw materials",
    "N8.4 Cosmetics and health care products",
    "N8.5 Wood vinegar",
    "N8.6 Pyroligneous acid",
    "N9.1 Nuts",
    "N9.2 Tea",
    "N9.3 Palm-hearts",
    "N9.4 Mushrooms, truffles",
    "N9.5 Fruits",
    "N9.6 Sap-based foods",
    "N9.7 Game",
    "N9.8 Honey",
    "P1.1 Mechanical pulp, bleached",
    "P1.2 Mechanical pulp, unbleached",
    "P1.3 Chemical pulp, bleached",
    "P1.4 Chemical pulp, unbleached",
    "P1.5 Semi-chemical pulp, bleached",
    "P1.6 Semi-chemical pulp, unbleached",
    "P1.7 Dissolving pulp",
    "P1.8 Pulp from recovered paper",
    "P2.1 Copying, printing, communication paper",
    "P2.2 Newsprint",
    "P2.3 Wrapping and packaging paper",
    "P2.4 Specialty paper",
    "P2.5 Hand-made papers",
    "P2.6 Tissue paper",
    "P3.1 Uncoated paperboard",
    "P3.2 Coated paperboard",
    "P3.3 Pressboard",
    "P3.4 Paperboardlaminates",
    "P3.5 Metalized paperboard",
    "P3.6 Crepe paperboard",
    "P4.1 Linerboard or testliner",
    "P4.2 Fluting",
    "P4.3 Corrugated fibreboard",
    "P5.1 Cardboard packaging",
    "P5.2 Corrugated paper packaging",
    "P5.3 Sacks and bags of paper",
    "P5.4 Food wrapping paper",
    "P5.5 Carton packfor beverages and liquidfood",
    "P5.6 Egg boxes and similar",
    "P5.7 Optical disc packaging and covers",
    "P6.1 Cleaning tissues and paper towels",
    "P6.2 Facial tissues and refreshing tissues",
    "P6.3 Napkins / serviettes",
    "P6.4 Toilet paper / bathroom tissue",
    "P6.5 Sanitary towels, tampons, diapers and similar",
    "P6.6 Tablecloths",
    "P6.7 Dinnerware",
    "P6.8 Medical supplies made of pulp/paper",
    "P7.10 Postage stamps",
    "P7.1 Notebooks",
    "P7.2 Pads",
    "P7.3 File folders",
    "P7.4 Rolled thermal paper",
    "P7.5 Post and greeting cards",
    "P7.6 Envelopes",
    "P7.7 Gummed papers",
    "P7.8 Adhesive labels",
    "P7.9 Transfers",
    "P8.1 Books",
    "P8.2 Magazines",
    "P8.3 Newspaper",
    "P8.4 Advertising materials",
    "P8.5 Business cards",
    "P8.6 Calendars, diaries and organisers",
    "P8.7 Toys and games made with paper",
    "P8.8 Wallpapers",
    "W1.1 Roundwood (logs)",
    "W1.2 Fuel wood",
    "W1.3 Twigs",
    "W10.1 Solid wood packaging",
    "W10.2 Cable-drums",
    "W10.3 Pallets and skids",
    "W10.4 Cooper's products",
    "W10.5 Container flooring",
    "W11.10 Wooden insulation",
    "W11.11 Window blinds, shutters etc",
    "W11.12 Houses and building elements",
    "W11.13 Marine constructions, excl. boats",
    "W11.14 Trusses and roofs",
    "W11.15 Roofing tiles",
    "W11.1 Doors and door frames",
    "W11.2 Windows and window frames",
    "W11.3 Stairs",
    "W11.4 Dividers",
    "W11.5 Flooring",
    "W11.6 Gates and garage doors",
    "W11.7 Wall cladding",
    "W11.8 Mouldings",
    "W11.9 Hot tubs and sauna",
    "W12.10 Cupboards and chests",
    "W12.11 Kitchen countertops",
    "W12.12 Parts of furniture",
    "W12.13 Shelves",
    "W12.1 Cabinet",
    "W12.2 Custom furniture",
    "W12.3 Tables",
    "W12.4 Beds",
    "W12.5 Couches and armchairs",
    "W12.6 Chairs and stools",
    "W12.7 Office furniture",
    "W12.8 Institutional casework",
    "W12.9 Wardrobes",
    "W13.1 Garden furniture",
    "W13.2 Trellis and plant support",
    "W13.3 Shelters and parasols",
    "W13.4 Fences, fence stakes, pales",
    "W13.5 Decking and garden sleepers",
    "W13.6 Garden sheds",
    "W13.7 Other furniture and garden prod.",
    "W14.1 String musical instruments",
    "W14.2 Keyboard musical instruments",
    "W14.3 Wind or mouth-blown instruments",
    "W14.4 Percussions",
    "W14.5 Parts of musical instruments",
    "W15.1 Playground equipment",
    "W15.2 Toys and games made with wood",
    "W15.3 Sporting goods",
    "W16.10 Bath items or accessories",
    "W16.1 Wooden frames",
    "W16.2 Brooms, brushes and brush handles",
    "W16.3 Tableware, kitchenware and similar",
    "W16.4 Clothes hangers and pegs",
    "W16.5 Toilet seats",
    "W16.6 Matches",
    "W16.7 Mousetraps",
    "W16.8 Fans",
    "W16.9 Ladders",
    "W17.1 Pens",
    "W17.2 Pencils",
    "W17.3 Rulers",
    "W17.4 Stamps",
    "W18.10 Boats",
    "W18.11 Wooden lighters",
    "W18.12 Wildlife and pet products",
    "W18.1 Dowels and turnery parts of wood",
    "W18.2 Coffins",
    "W18.3 Medical supplies made of wood",
    "W18.4 Tools, tool bodies and handles",
    "W18.5 Icepop/lollysticks",
    "W18.6 Jewellery",
    "W18.7 Works of art",
    "W18.8 Ornamental & decorative objects",
    "W18.9 Wheels",
    "W3.1 Wood chips",
    "W3.2 Sawdust",
    "W3.3 Wood shavings",
    "W3.4 Wood wool",
    "W3.5 Wood flour",
    "W3.6 Wood pellets",
    "W3.7 Sawdust briquettes",
    "W4.1 Impregnated roundwood",
    "W4.2 Impregnated railway sleepers/ties",
    "W4.3 Treated dimensional lumber, plywood",
    "W5.1 Flitches and boules",
    "W5.2 Solid wood boards",
    "W5.3 Beams",
    "W5.4 Planks",
    "W5.5 Poles and piles",
    "W5.6 Railway ties, not impregnated",
    "W5.7 Raw wood for parquet flooring",
    "W5.8 Slabs and edgings",
    "W5.9 Pencil slats",
    "W6.1 Dimensional lumber, finished",
    "W6.2 Non-dimensional timber and lumber",
    "W6.3 Boards, finished",
    "W7.1 Peeled veneer",
    "W7.2 Sliced veneer",
    "W7.3 Sawn veneer",
    "W7.4 Veneer strips",
    "W8.1 Plywood",
    "W8.2 Particleboard",
    "W8.3 Fibreboard",
    "W9.10 Compressed wood",
    "W9.11 Wood-plastic composites",
    "W9.1 Finger jointed wood",
    "W9.2 Laminated veneer lumber (LVL)",
    "W9.3 Parallel strand lumber (PSL)",
    "W9.4 Wood-wool board",
    "W9.5 Solid-wood board",
    "W9.6 Glued laminated timber (GLULAM)",
    "W9.7 I-joists, I-beams",
    "W9.8 Laminated compressed wood",
    "W9.9 Composite board"
]

const level3AllOptions = [
    "030101 Flitches, boules and slabs",
    "030102 Solid wood boards and planks",
    "030103 Beams",
    "030104 Poles and piles",
    "030105 Peeler cores",
    "030106 Pencil slat",
    "030107 Other sawnwood",
    "050501 Chipboard",
    "050502 OSB",
    "050503 Other particle board",
    "050601 Medium Density Fiberboard (MDF)",
    "050602 High Density Fiberboard (HDF)",
    "050603 Softboard and insulating board",
    "060101 Packaging and crates",
    "060102 Cable drums",
    "060103 Pallets",
    "060104 Barrels, staves and other",
    "060201 Wooden frames",
    "060202 Brushes and handles",
    "060203 Kitchenware and similar utensils",
    "060204 Hangers and clothes pegs",
    "060205 Matches",
    "060206 Bathroom accessories",
    "060207 Ladders",
    "060208 Wood based insect repellent",
    "060209 Other household products",
    "060301 Tools, DIY tools",
    "060302 Toys and games",
    "060303 Sport goods",
    "060304 Musical instruments",
    "060305 Wooden stationery",
    "060306 Dowels",
    "060307 Decorative objects and art",
    "060308 Jewellery and accessories",
    "060309 Ice cream / lolly sticks",
    "060310 Other tools and turned wood",
    "060401 Coffins",
    "060402 Others",
    "080101 Garden furniture",
    "080103 Decking and garden sleepers",
    "080201 Garden sheds",
    "080202 Trellis and plant support",
    "080203 Fencing material",
    "080204 Pergolas",
    "080205 Garden storage",
    "090101 Wooden House building",
    "090102 Other wooden building",
    "090103 Wooden bridge",
    "090104 Wooden Ship",
    "090105 Other Wooden construction",
    "090201 Exterior",
    "090202 Structure",
    "090203 Roof",
    "090204 Wall",
    "090205 Floor",
    "090206 Interior",
    "090301 Windows",
    "090302 Doors",
    "090303 Shingles and shakes",
    "090304 Flooring",
    "090305 Architectural joinery items",
    "090306 Engineered Bridge Components",
    "090307 Other wood material for construction",
    "100301 cellulosic fibre from dissolving",
    "100302 cellulosic yarn",
    "100303 cellulosic textile",
    "100304 Apparel",
    "100305 non-wovens fabrics",
    "100306 Regenerated cellulose film",
    "100307 Other dissolving pulp derivatives",
    "100401 Unbleached sulphite pulp",
    "100402 Bleached sulphite pulp",
    "100403 Unbleached sulphate (kraft) pulp",
    "100404 Bleached sulphate (kraft) pulp",
    "100405 Fluff pulp",
    "110101 Newsprint paper",
    "110102 Uncoated mechanical papers",
    "110103 Coated mechanical papers",
    "110104 Woodfree papers (coated and uncoated)",
    "110105 Paper for blank forms",
    "110106 Paper for tickets",
    "110107 Other graphic papers",
    "110201 Books",
    "110202 Book covers",
    "110203 Magazines and Newspaper",
    "110204 Paper toys and games",
    "110205 Marketing collateral",
    "110206 Calendars, diaries and organisers",
    "110207 Point-of-sales materials",
    "110208 Other printed matter",
    "110301 Tissues products",
    "110302 Toilet paper / bathroom tissue",
    "110303 Greaseproof paper for baking",
    "110304 Kitchen paper",
    "110305 Tablecloths and napkins",
    "110306 Paper dinnerware",
    "110307 Sanitary products",
    "110308 Medical supplies",
    "110309 Wet wipes",
    "110310 Other household and sanitary",
    "110401 Case materials and corrugated and Solid Fiber Box",
    "110402 Cartonboard, Folding boxboards",
    "110403 Wrapping papers",
    "110404 Sacks and Paper bags",
    "110405 Food and beverages packaging",
    "110406 Multipack holders",
    "110407 Flexible paper packaging",
    "110408 Paper trays, containers, cups",
    "110409 Shredded paper",
    "110410 Egg boxes and similar",
    "110411 Other papers mainly for packaging",
    "110501 Notebooks",
    "110502 Pads",
    "110503 File folders",
    "110504 Rolled thermal paper",
    "110505 Post and greeting cards",
    "110506 Envelopes",
    "110507 Gummed papers",
    "110508 Adhesive labels",
    "110509 Postage stamps",
    "110510 Other stationary products",
    "110601 Cigarette paper",
    "110602 Envelope paper",
    "110603 Filter paper",
    "110604 Insulating paper",
    "110605 Impregnated paper",
    "110606 Wallpaper and wallpaper base",
    "120101 Natural cork, raw or boiled",
    "120102 Cork stoppers",
    "120103 Cork disks",
    "120104 Rolls and panels of compressed cork",
    "120105 Cork particles",
    "120106 Cork for construction",
    "120107 Other articles of cork",
    "120201 Natural rubber",
    "120202 Tyres",
    "120203 Foam",
    "120204 Gloves",
    "120205 Rubber footwear",
    "120206 Other rubber products",
    "120301 Honey",
    "120302 Mushrooms and truffles",
    "120303 Fruits, berries and nuts",
    "120304 Syrups",
    "120305 Game and other animals",
    "120306 Other edible products",
    "120601 Natural",
    "120602 Products",
    "N6.3.1 Christmas trees",
    "N7.1.1 Natural rubber",
    "N7.1.2 Tyres",
    "N7.1.3 Balls",
    "N7.1.4 Footwear",
    "N7.1.5 Rubber foam pillows, mattresses",
    "N7.1.6 Balata, gutta-percha, guayule",
    "N7.1.7 Other manufactured rubber prods.",
    "N9.6.1 Maple syrup or sugar",
    "N9.6.2 Birch syrup or sugar",
    "P1.1.1 Groundwood",
    "P1.1.2 Refiner pulp",
    "P1.2.1 Groundwood",
    "P1.2.2 Refiner pulp",
    "P1.7.1 Specialty cellulose",
    "P1.7.2 Cellulose derivatives",
    "P1.7.3 Regenerated cellulose film",
    "P1.7.4 Rayon and other synthetic fibres",
    "P1.8.1 Recovered pulp, deinked",
    "P1.8.2 Recovered pulp, not deinked",
    "P2.1.1 Coated paper",
    "P2.1.2 Uncoated paper",
    "P2.4.10 Composite papers",
    "P2.4.11 Wallpaper base",
    "P2.4.12 Security paper",
    "P2.4.1 Impregnated papers",
    "P2.4.2 Photographic base papers",
    "P2.4.3 Thermographic papers",
    "P2.4.4 Translucent papers",
    "P2.4.5 Self-copying and carbon papers",
    "P2.4.6 Cigarette papers",
    "P2.4.7 Filter papers",
    "P2.4.8 Crepe papers",
    "P2.4.9 Embossed and perforated paper",
    "P3.4.1 High-pressure laminates",
    "P3.4.2 Low-pressure laminates",
    "P3.4.3 Continuous pressure laminates",
    "W11.5.1 Laminate flooring",
    "W11.5.2 Parquet flooring",
    "W11.5.3 Plank flooring",
    "W11.5.4 Wood-block flooring",
    "W11.5.5 Engineered flooring",
    "W13.1.1 Garden tables",
    "W13.1.2 Gardenbenches",
    "W13.1.3 Garden chairs and stools",
    "W13.1.4 Hammocks and hammock frames",
    "W15.3.1 Bicycles",
    "W15.3.2 Bats, sticks, poles and paddles",
    "W15.3.3 Boards and skis",
    "W15.3.4 Other sporting goods",
    "W4.3.1 Treated glued laminated timber",
    "W4.3.2 Treated finger jointed lumber",
    "W8.1.1 Laminboard",
    "W8.1.2 Veneer plywood",
    "W8.2.1 Melamineparticleboard",
    "W8.2.2 Veneered particleboard",
    "W8.2.3 Oriented Strand Board(OSB)",
    "W8.2.4 Smooth-surface panel",
    "W8.2.5 Wood cement particleboard",
    "W8.2.6 Plasterboard",
    "W8.2.7 Strawboard",
    "W8.2.8 Graded particleboard",
    "W8.3.1 High-density fibreboard (HDF)",
    "W8.3.2 Medium-density fibreboard (MDF)",
    "W8.3.3 Softboard",
    "W8.3.4 Medium-hard-fibreboard",
    "080102 Playground equipment"
]

const fscOutputClaim = [
    "FSC 100%",
    "FSC Mix",
    "FSC Recycled",
    "FSC Controlled Wood"
]

const primaryActivity = [
    "Brokers/Traders with physical possession",
    "Brokers/Traders without physical possession",
    "Distributor/Wholesaler",
    "Gathering of non-wood products",
    "Logging",
    "Primary Processor",
    "Printing and related service",
    "Publishing activities",
    "Retailers",
    "Secondary Processor"
];

const secondaryActivity = [
    "Brokers/Traders without physical possession",
    "Brokers/Traders with physical possession",
    "Distributor/Wholesaler",
    "Gathering of non-wood products",
    "Logging",
    "Primary Processor",
    "Printing and related service",
    "Publishing activities",
    "Retailers",
    "Secondary Processor"
]

export const getLevel2Options = (level1: string) => {
    let level1Code = level1?.split(' ')[0];
    if(!isNaN(parseInt(level1Code))){
        // get first three characters
        level1Code = level1Code.substring(0, 3);
    }
    return level2AllOptions.filter((item) => item.startsWith(level1Code));
}

export const getLevel3Options = (level2: string) => {
    let level2Code = level2?.split(' ')[0];
    if(!isNaN(parseInt(level2Code))){
        // get first four characters
        level2Code = level2Code.substring(0, 4);
    }
    return level3AllOptions.filter((item) => item.startsWith(level2Code));
}

export const getOptions = (data: string[]) => data.map((item, index) => ({
    id: index,
    label: item,
    value: item
}));

export const optionsData = {
    productCodeL1: getOptions(level1),
    fscOutputClaim: getOptions(fscOutputClaim),
    primaryActivity: getOptions(primaryActivity),
    secondaryActivity: getOptions(secondaryActivity),
}